<script setup>
import { ref, computed, watch, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'

import SuTableTab from '@/components/suTable/SuTableTab.vue'
import SoilTypeTab from '@/components/soil-type/SoilTypeTab.vue'

const store = useStore()
const router = useRouter()
const route = useRoute()

const tab = ref('soil-type')

const currentProject = computed(() => store.state.project.currentProject)
const loading = computed(() => store.state.soilType.loading)
const selectedSoilTypeRevision = computed(() => store.getters['project/selectedSoilTypeRevision'])

const fetchBaseItems = (payload) => store.dispatch('baseSoilType/fetchItems', payload)
const fetchBaseOptions = () => store.dispatch('baseSoilType/fetchOptions')
const fetchItemsAdd = (payload) => store.dispatch('soilType/fetchItemsAdd', payload)
const resetDirtyItems = () => store.dispatch('soilType/resetDirtyItems')
const fetchSoilTypeOptions = () => store.dispatch('soilType/fetchOptions')
const fetchSuTableItems = (payload) => store.dispatch('suTable/fetchItems', payload)
const fetchSuTableOptions = () => store.dispatch('suTable/fetchOptions')
const fetchSuTablePointItems = (payload) => store.dispatch('suTablePoint/fetchItems', payload)
const fetchSuTablePointOptions = () => store.dispatch('suTablePoint/fetchOptions')

const fetchAddSoilTypes = async () => {
  resetDirtyItems()
  if (!loading.value) {
    const revisionId = parseInt(route.params.revisionId)
    await fetchItemsAdd(revisionId)
  }
}

watch(tab, (value) => {
  router.replace({ query: { tab: value } })
})

// Lifecycle
onMounted(async () => {
  const queryTab = route.query.tab
  if (queryTab) {
    tab.value = queryTab
  } else {
    router.replace({ query: { tab: 'soil-type' } })
  }
  await fetchBaseOptions()
  await fetchSoilTypeOptions()
  await fetchSuTableOptions()
  await fetchSuTablePointOptions()
  await fetchBaseItems(currentProject.value.id)
  await fetchSuTableItems(currentProject.value.id)
  await fetchSuTablePointItems(currentProject.value.id)

  if (selectedSoilTypeRevision.value) {
    await fetchAddSoilTypes()
  }
})
</script>

<template>
  <v-tabs v-model="tab" color="primary">
    <v-tab value="soil-type" class="text-none" rounded="0">Soil type</v-tab>
    <v-tab value="su-table" class="text-none" rounded="0">Su table</v-tab>
  </v-tabs>
  <v-window v-model="tab">
    <v-window-item value="soil-type">
      <SoilTypeTab />
    </v-window-item>
    <v-window-item value="su-table">
      <SuTableTab />
    </v-window-item>
  </v-window>
</template>

<style scoped>
.v-card__title {
  padding-bottom: unset !important;
}
</style>
